<template>
  <div class="toggle"
       :class="{'--active': checked,
                '--size-xl': size === 'xl',
                '--size-lg': size === 'lg'}"
       @click="$emit('change', !checked)">
    <div class="toggle-box">
      <div class="toggle-indicator"></div>
    </div>
    <label>
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: "BaseToggle",
  props: {
    checked: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: 'sm',
      validator: (size) => ['sm', 'lg', 'xl'].includes(size)
    }
  }
}
</script>

<style scoped lang="scss">
.toggle {
  position: relative;
  @apply inline-flex items-center cursor-pointer;
  .toggle-box {
    @apply bg-border flex p-px transition duration-200 ;
    width: 25px;
    min-width: 25px;
    border-radius: 15px;
  }

  .toggle-indicator {
    @apply bg-white rounded-full transition duration-200 ml-0;
    width: 13px;
    height: 13px;
    transition: all .2s;
  }

  &.--active {
    .toggle-box {
      @apply bg-green;
    }

    .toggle-indicator {
      @apply ml-auto;
    }
  }

  &.--size-xl {
    .toggle-box {
      padding: 2px;
      width: 50px;
      min-width: 50px;
    }

    .toggle-indicator {
      width: 26px;
      height: 26px;
    }
  }

  &.--size-lg {
    .toggle-box {
      padding: 2px;
      width: 40px;
      min-width: 40px;
    }

    .toggle-indicator {
      width: 22px;
      height: 22px;
    }
  }

  label {
    @apply pl-4 text-2sm text-bg-contractor leading-snug;
    cursor: pointer;
  }
}
</style>